<a class="card lc-card lc-card-cols-3 lc-icon-card hoverable" [href]="href" target="_blank">
  <div><img class="lc-icon" [src]="iconURL" alt="" /></div>
  <div class="lc-flex-container">
    <h3 class="lc-title">{{ title }}</h3>
    <ng-content/>
  </div>
</a>
